import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import ListPlan from "../Plan/ListPlan";
import SelectPlantype from "../Plan/SelectPlantype";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsConditions from "./TermsConditions";

export interface PoliciesRef {
    AddSelet_plan: (data?: any) => void
}

interface Props {
    selectedTab: number,
    setSelectedTab: React.Dispatch<React.SetStateAction<number>>
}

const PoliciesPlans = forwardRef<PoliciesRef, Props>(({ selectedTab, setSelectedTab }, ref) => {


    const clickTab = (tabIndex: React.SetStateAction<number>) => {
        setSelectedTab(tabIndex);
    };

    // Billing Plan States
    const [SingleMarketResearch, setMarketResearch] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const planref: any = useRef(null);
    const [allData, setAllData] = useState([]);


    const AddSelet_plan = (data?: any) => {
        setMarketResearch(data);
        setIsModalOpen(true);
    };

    const getDataALL = () => {
        console.log("fffffffff");
        planref?.current?.getDataALL();
    };


    const closeModal = () => {
        setIsModalOpen(false);
    };

    useImperativeHandle(ref, () => ({
        AddSelet_plan: AddSelet_plan,

    }));

    return (
        <>
            <div className="rightside">
                <div className="allscreen">

                    <div className="loadlisting">

                        <div >
                            <div className="flex-between px-3">
                                <div className="flex-gap">

                                    <button
                                        className={` px-2 py-[6px] text-sm  lg:px-4 lg:py-[6px]  rounded-md font-medium border-[1px]  
                               ${selectedTab === 1 ? 'border-customOrange text-customOrange' : ' border-gray-200 '}`}
                                        onClick={() => clickTab(1)}
                                    >
                                        Privacy Policy
                                    </button>

                                    <button
                                        className={` px-2 py-[6px] text-sm  lg:px-4 lg:py-[6px]  rounded-md font-medium border-[1px]  
                               ${selectedTab === 2 ? 'border-customOrange text-customOrange' : ' border-gray-200 '}`}
                                        onClick={() => clickTab(2)}
                                    >
                                        Terms Conditions
                                    </button>

                                    <button
                                        className={` px-2 py-[6px] text-sm  lg:px-4 lg:py-[6px]  rounded-md font-medium border-[1px]  
                               ${selectedTab === 3 ? 'border-customOrange text-customOrange' : ' border-gray-200 '}`}
                                        onClick={() => clickTab(3)}
                                    >
                                        Billing Plan
                                    </button>



                                </div>

                            </div>
                            {selectedTab === 1 && (
                                <PrivacyPolicy />
                            )}
                            {selectedTab === 2 && (
                                <TermsConditions />)}

                            {selectedTab === 3 && (
                                <ListPlan
                                    ref={planref}
                                    allData={allData}
                                    setAllData={setAllData}
                                ></ListPlan>
                            )}

                        </div>
                    </div>

                </div>
            </div>

            {/* Modals */}

            <SelectPlantype
                isOpen={isModalOpen}
                closeModal={closeModal}
                getDataALLs={getDataALL}
            />

        </>
    );
});

export default PoliciesPlans;
